module.exports = __webpack_public_path__ + "img/15.81c79a92.png";